import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { LazyStylesService } from '@cue/lazy-styles';
import { loadNavigationLeafletStyles } from '../../lazy-styles/navigation-lazy-styles';

@Component({
  selector: 'cue-leaflet-styles',
  imports: [],
  host: {
    kiosk: 'kioskMode()',
  },
  templateUrl: './leaflet-styles.component.html',
  styleUrl: './leaflet-styles.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LeafletStylesComponent implements OnInit {
  private lazyStyles = inject(LazyStylesService);

  kioskMode = input<boolean, boolean | 'true' | 'false'>(false, {
    transform: booleanAttribute,
  });

  ngOnInit(): void {
    void loadNavigationLeafletStyles(this.lazyStyles);
  }
}
